import { render } from "./FilterPopover.vue?vue&type=template&id=12c4e792&scoped=true"
import script from "./FilterPopover.vue?vue&type=script&lang=js"
export * from "./FilterPopover.vue?vue&type=script&lang=js"

import "./FilterPopover.vue?vue&type=style&index=0&id=12c4e792&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c4e792"]])

export default __exports__